export default __webpack_public_path__ + "static/media/handHoldingPhone.218ef182.png";